// JsFromRoutes CacheKey a3941ba4ee8fa1ef1a87b71df1e38b98
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/setup/website'),
}
